import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import { type IngressPromptFormProps } from '../IngressPromptForm';
import I18NextLoader from '../I18NextLoader';

const ReduxLoader = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "dreamup_form" */
        '../ReduxLoader'
      )
  )
);

const IngressPromptFormLoader = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "dreamup_form" */
        '../IngressPromptForm'
      )
  )
);

interface Props extends IngressPromptFormProps {
  fallback?: React.ReactNode;
}

const LoadableIngressForm: React.FC<Props> = ({ fallback, ...rest }) => {
  const isMounted = useIsMounted();

  if (!isMounted) {
    return null; // never SSR
  }

  return (
    <ErrorBoundary debugComponent="EditorLoadableWrapper">
      <Suspense fallback={fallback ?? <LoadingIndicator view={'llama'} coverMode />}>
        <I18NextLoader />
        <ReduxLoader />
        <IngressPromptFormLoader {...rest} />
      </Suspense>
    </ErrorBoundary>
  );
};

LoadableIngressForm.displayName = 'LoadableIngressForm';

export default LoadableIngressForm;
